import { render, staticRenderFns } from "./EtiquetasGestãoGondola.vue?vue&type=template&id=44adac1a&scoped=true"
import script from "./EtiquetasGestãoGondola.vue?vue&type=script&lang=js"
export * from "./EtiquetasGestãoGondola.vue?vue&type=script&lang=js"
import style0 from "./EtiquetasGestãoGondola.vue?vue&type=style&index=0&id=44adac1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44adac1a",
  null
  
)

export default component.exports